import styled from 'styled-components';

import Icon from 'components/Icon';

import {checklistColors} from 'styles/palette';

import {OPTION_TYPES} from './constants';

const {CHECKMARK, CLOSE} = OPTION_TYPES;

export const StepChecksOptionWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const optionBase = `
  border-radius: 5px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media(max-width: 1100px){
    width:40px;
    height: 40px;
  }
`;

export const OptionCheck = styled.div`
  ${optionBase}
  border: 2px solid ${checklistColors.green};
  margin: 15px 0 15px 0;
  background-color: ${({checked}) => (checked ? checklistColors.green : checklistColors.white)};
`;

export const OptionUncheck = styled.div`
  ${optionBase}
  border: 2px solid ${checklistColors.red};
  margin: 15px 0 15px 15px;
  background-color: ${({unChecked}) => (unChecked ? checklistColors.red : checklistColors.white)};
`;

export const StyledCheckIcon = styled(Icon).attrs({
  name: CHECKMARK
})`
  height: 25px;
  color: ${({checked}) => (checked ? checklistColors.white : checklistColors.green)};
`;

export const StyledUncheckIcon = styled(Icon).attrs({
  name: CLOSE
})`
  height: 15px;
  color: ${({unChecked}) => (unChecked ? checklistColors.white : checklistColors.red)};
`;
